import React from "react";
import Layout from "@/components/_layout";
import { SWRConfig } from "swr";
// import NextNProgress from "nextjs-progressbar";
import axios from "axios";
import "@/styles/globals.css";
import GlobalProvider from "@/context/globalContext";
import { TranslationProvider } from "@/context/TranslationContext";

export default function App({ Component, pageProps }) {
  const fetcher = (url) => axios.get(url).then((res) => res.data);
  return (
    <SWRConfig
      value={{
        fetcher,
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
      }}
    >
      <TranslationProvider>
        <GlobalProvider>
          <Layout {...pageProps}>
            {/* <NextNProgress options={{ showSpinner: false }} /> */}
            <Component {...pageProps} />
          </Layout>
        </GlobalProvider>
      </TranslationProvider>
    </SWRConfig>
  );
}
